import { DO_NOT_EXPORT, DEFAULT_VALUE } from '$utils/overrideConstants';
import notEmptyArray from './notEmptyArray';

const getLastOverride = ({ lastJob, studentGrade }) => {
  const { overrides } = lastJob || {};

  if (notEmptyArray(overrides)) {
    const lastStudentOverride = overrides.find(
      ({ studentId }) => studentId === studentGrade.studentId
    );

    if (lastStudentOverride) {
      return lastStudentOverride.code;
    }
  }

  return studentGrade && studentGrade.displayGrade
    ? DEFAULT_VALUE
    : DO_NOT_EXPORT;
};

export default getLastOverride;
